export default __webpack_public_path__ + "static/media/MovieRecommendation.f2fa14c7.png";